import cn from 'classnames';
import './toggleSwitch.style.scss';

interface IToggleSwitch {
  isToggled?: boolean;
  onToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  size?: 'xs' | 'md' | 'lg';
  disabled?: boolean;
}

const ToggleSwitch = ({
  isToggled,
  onToggle,
  name,
  disabled,
  size = 'md',
}: IToggleSwitch) => {
  return (
    <label className={cn('toggle-switch', {smallerSize: size === 'xs'})}>
      <input
        type="checkbox"
        checked={isToggled}
        onChange={onToggle}
        name={name}
        disabled={disabled}
      />
      <span className="switch" />
    </label>
  );
};
export default ToggleSwitch;
